import Container from '@/container';
import {Col, Grid, Row} from '@/grid';
import {withMarginBottom2xl, withMarginBottomSm} from '@/hocs/withSpacing';
import Link from '@/links';
import ScrollingHandler from '@/scrollinghandler';
import {SectionPadding} from '@/section';
import {H2Neutral50, H3, P} from '@/typography';
import {withNeutral50} from '@/hocs/withColors';
import BoxGrid from '@/ui/box-grid';
import {GridItem, GridLayout} from '@/ui/grid/grid-layout';
import {ListTerms} from '@/ui/lists/list-icons';
import Pill from '@/ui/pills';
import partnersStyles from 'pages/partnership-program/partners.module.scss';

const H3marginedSm = withMarginBottomSm(H3);
const SubPNeutral50 = withNeutral50(P);
const DivMargined2xl = withMarginBottom2xl('div');
const DivMarginedSm = withMarginBottomSm('div');
const prepareLink = ScrollingHandler.prepareOnClick;

const exploreOptionsArray = [
  {
    pillCopy: 'Native integration partners',
    boxes: [
      {
        title: 'Requirements',
        list: [
          'Minimum of 15 mutual customers. Leverages our Partner API. This option involves collaboration with our Product team and is subject to availability.'
        ],
        minHeight: 210
      },
      {
        title: 'Discoverability',
        list: ['Partners page listing within Workable.', 'Partner Directory listing.'],
        minHeight: 150
      },
      {
        title: 'Rate limits',
        list: ['50 requests / 10 seconds.'],
        minHeight: 130
      },
      {
        title: 'Support',
        list: [
          'Workable provides first level support for customer troubleshooting.',
          'Dedicated technical support during your build.'
        ],
        minHeight: 190
      },
      {
        title: 'Co-marketing',
        list: [
          <>
            Native integration partners have the possibility to participate in webinars, blog swaps,
            ebooks, etc (at Workable Marketing’s discretion). Workable will make a dedicated social
            post to announce the integration and partnership.
            <br />
            <br />
            The new partnership will be included in Workable’s{' '}
            <Link href="/recent-updates" variant="default">
              Recent Updates
            </Link>
          </>
        ],
        minHeight: 250
      }
    ],
    linkUrl: '#native-integration-partners'
  },
  {
    pillCopy: '3rd party integration partners',
    boxes: [
      {
        title: 'Requirements',
        list: [
          'Offers flexibility for integration builds. No requirement for mutual customers. Can be through a unified API provider, IPaaS, Zapier, Workable Public API. Partners can begin their build at any time.'
        ],
        minHeight: 210
      },
      {
        title: 'Discoverability',
        list: ['Partner Directory listing.'],
        minHeight: 150
      },
      {
        title: 'Rate limits',
        list: ['10 requests / 10 seconds.'],
        minHeight: 130
      },
      {
        title: 'Support',
        list: ['Support is owned and managed by the partner.'],
        minHeight: 190
      },
      {
        title: 'Co-marketing',
        list: [
          <>
            3rd party integration partners receive a shoutout at launch in our monthly partner
            newsletter and our recurring social announcements highlighting new cohorts of partners
            <br />
            <br />
            The new partnership will be included in Workable’s{' '}
            <Link href="/recent-updates" variant="default">
              Recent Updates
            </Link>
          </>
        ],
        minHeight: 250
      }
    ],
    linkUrl: '#third-party-integration-partners'
  }
];
const PillMargined = withMarginBottomSm(Pill);

const ExploreOptions = () => (
  <div className={partnersStyles['image-overlay']}>
    <img
      className={partnersStyles['bg-img']}
      loading="lazy"
      src="/static/images/partnership-program/technology-partners/explore-options/partnership-options-desktop.jpg"
      alt="Background image with vertical linear gradient having shades of light green, white and red"
    />
    <SectionPadding id="find-the-right-partnership" className={partnersStyles.content}>
      <Container>
        <Grid fluid>
          <DivMargined2xl>
            <Row center="xs">
              <Col xs={12} lg={10}>
                <H2Neutral50>Explore our partnership options</H2Neutral50>
                <SubPNeutral50>
                  See how partnering with best-in-class recruiting and HR tools enables powerful,
                  seamless integrations that enhance the user experience, deliver more value to
                  customers, and unlock new growth opportunities for both sides.
                </SubPNeutral50>
              </Col>
            </Row>
          </DivMargined2xl>
          <Row>
            <Col xs={12}>
              <GridLayout lgCol={1} Col={2} autoRows>
                {exploreOptionsArray.map((item, itemIndex) => (
                  <GridItem key={itemIndex}>
                    <div className={partnersStyles['partner-box']}>
                      <PillMargined variant="neutral900">{item.pillCopy}</PillMargined>
                      {item.boxes.map((box, boxIndex) => (
                        <DivMarginedSm key={boxIndex}>
                          <BoxGrid border="neutral400" minHeight={box.minHeight}>
                            <H3marginedSm className="heading-4">{box.title}</H3marginedSm>
                            <ListTerms>
                              {box.list.map((listItem, listIndex) => (
                                <li key={listIndex}>{listItem}</li>
                              ))}
                            </ListTerms>
                          </BoxGrid>
                        </DivMarginedSm>
                      ))}
                      <div>
                        <Link
                          href={item.linkUrl}
                          variant="secondary-sm"
                          onClick={prepareLink(item.linkUrl)}>
                          How to get started
                        </Link>
                      </div>
                    </div>
                  </GridItem>
                ))}
              </GridLayout>
            </Col>
          </Row>
        </Grid>
      </Container>
    </SectionPadding>
  </div>
);

export default ExploreOptions;
